var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-details-box" }, [
    _c(
      "div",
      { staticClass: "event-registration-box" },
      [
        _c("payment-summary", {
          attrs: {
            formTitle: _vm.eventConfig["names-label-your-total"],
            priceTitle: "",
            products: _vm.products,
            donationPrice: 0,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "event-form-wrap event-box-shadow" }, [
      _c("div", { staticClass: "event-rg-form" }, [
        _c("h6", { staticClass: "mb-3" }, [
          _vm._v(_vm._s(_vm.eventConfig["payment-label-details"])),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-payment" }, [
          _c("div", [
            _c("div", { staticClass: "event-rg-form event-form-step1" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.processing,
                      expression: "processing",
                    },
                  ],
                  attrs: { "element-loading-text": "Processing..." },
                },
                [
                  _vm.errors
                    ? _c(
                        "el-alert",
                        {
                          ref: "alert-item",
                          attrs: { type: "error", "show-icon": "" },
                        },
                        [
                          _c("p", {
                            domProps: { innerHTML: _vm._s(_vm.errors) },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h5", { staticClass: "text-center mt-5 mb-5" }, [
                    _vm._v("Payment is not required"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(
                      "Please ensure that you click ‘Submit’ below to register."
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-btn d-flex flex-wrap event-rg-form" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { disabled: _vm.processing },
                    on: { click: _vm.onBackClick },
                  },
                  [_vm._v("Back")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { disabled: _vm.processing },
                    on: { click: _vm.onNextClick },
                  },
                  [_vm._v("Submit")]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }